var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkBenefitLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 443,
    viewBox: "0 0 137 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.848 8.428c-1.108 56.817-15.871 115.17-58.968 158.578-27.446 27.759-62.443 46.696-100.57 54.417 38.129 7.714 73.129 26.653 100.57 54.418 41.117 41.413 57.624 97.044 59.023 150.876 0 2.539.097 5.079.097 7.604V443h-24.831c-3.268 0-6.536-.07-9.805-.237-47.986-2.33-96.345-21.697-132.476-58.101C-68.39 346.095-87.695 272.087-88 221.549v-.195c.305-50.637 19.596-124.533 57.901-163.127C6.85 20.986 56.622 1.59 105.62 0h31.229v8.428zM-16.444 374.406c0-.139 0 0 0 0z",
    fill: "#F7F3FF"
  })));
}
export default SvgWorkBenefitLeft;